export function isObjEmpty(obj) {
    return Object.values(obj).length === 0 && obj.constructor === Object;
}